const screenHeight = (state) => state.app.screenHeight
const screenWidth = (state) => state.app.screenWidth

const language = (state) => state.app.language
const translation = (state) => state.app.translation

const theme = (state) => state.app.theme

const displayLoader = (state) => state.app.displayLoader
const displayModal = (state) => state.app.displayModal
const displayMenu = (state) => state.app.displayMenu
const displayProfile = (state) => state.app.displayProfile

const alert = (state) => state.app.alert
const availablePages = (state) => state.app.availablePages

export default {
  screenHeight,
  screenWidth,

  language,
  translation,

  theme,

  displayLoader,
  displayModal,
  displayMenu,
  displayProfile,

  alert,
  availablePages,
}